var Event = function () {
  function Event(eventName, data) {
    this.eventName = eventName;
    this.data = data;
  }

  Event.MESSAGE_EVENT = "message";
  return Event;
}();

export default Event;